import api from '@/utils/api'

export default {
    // phase null: the leagues of any phase of the season
    getLeagues(page, size, season, phase) {
        const filter = '"active": true'
        const range = '?seasonId=' + season.id + (phase ? '&phase=' + phase : '')
        return api.get('leagues/based-on-season' + (page ? range : '') + (season ? '' : `&filter=${encodeURIComponent('{' + filter + '}')}`))
    },

    getCupLeagues(page, size, season) {
        const filter = '"active": true'
        const range = '?seasonId=' + season.id
        return api.get('cup-leagues' + (page ? range : '') + (season ? '' : `&filter=${encodeURIComponent('{' + filter + '}')}`) + '&sort=' + encodeURIComponent('[title, ASC]'))
    },

    getCupLeague(id) {
        return api.get(`cup-leagues/${id}`)
    },

    getLeague(id) {
        return api.get(`leagues/${id}`)
    },

    // every active league with its league group, whatever the season or phase (menu and home page)
    getActiveLeagues() {
        const range = '?range=' + encodeURIComponent('[0,200]')
        const filter = '&filter=' + encodeURIComponent('{"active":true}')
        return api.get('leagues' + range + filter + '&sort=' + encodeURIComponent('[title, ASC]'))
    },

    getAllLeagues() {
        return api.get('leagues/all')
    },

    getRankingByLeague(leagueId, seasonId, phase) {
        const filter = phase ? `?phase=${phase}&isCup=false` : null
        return api.get(`leagues/${leagueId}/season/${seasonId}/ranking` + filter)
    }
}
